<template>
  <div
    class="sticky z-10 hidden w-full lg:px-0 md:px-4 h-14 md:flex md:justify-between md:bg-white dark:bg-black dark:text-white md:top-0 top-2"
    :class="{ 'text-white dark:text-gray-300 bgBlack': scrollPosition > 1 }"
  >
    <div
      class="sticky z-10 flex justify-center w-full mx-auto maxWidth md:top-0 top-2"
    >
      <div class="flex items-center justify-start w-full">
        <a href="#home-page">
          <Muneeb />
        </a>
      </div>
      <div
        class="flex gap-3 no-underline bg-white rounded-md shadow-md md:bg-transparent p-7 md:p-4 md:rounded-none md:shadow-none"
        id="nav"
      >
        <a
          href="#home-page"
          class="text-base font-semibold text-black no-underline btn dark:text-gray-300"
          :class="{ colorChange: scrollPosition > 1 }"
          @click="active = 'Home'"
          >Home</a
        >
        <a
          href="#about-page"
          class="text-base font-semibold text-black no-underline btn dark:text-gray-300"
          :class="{ colorChange: scrollPosition > 1 }"
          >About</a
        >
        <a
          href="#resume-page"
          class="text-base font-semibold text-black no-underline btn dark:text-gray-300"
          :class="{ colorChange: scrollPosition > 1 }"
          >Resume</a
        >
        <a
          href="#work-page"
          class="text-base font-semibold text-black no-underline btn dark:text-gray-300"
          :class="{ colorChange: scrollPosition > 1 }"
          >Works</a
        >
        <a
          href="#contact-page"
          class="text-base font-semibold text-black no-underline btn dark:text-gray-300"
          :class="{ colorChange: scrollPosition > 1 }"
          >Contact</a
        >
      </div>
      <div class="flex items-center justify-end w-full">
        <!-- <DarkMode /> -->
      </div>
    </div>
  </div>
  <div
    class="fixed z-10 flex items-start justify-center w-full h-12 gap-3 md:hidden md:bg-white md:top-0 top-2"
  >
    <div
      class="flex gap-3 no-underline bg-white rounded-md shadow-md dark:bg-black md:bg-transparent p-7 md:p-2 md:rounded-none md:shadow-none"
      id="nav"
    >
      <a
        href="#home-page"
        class="text-base font-semibold text-black no-underline btn dark:text-white"
        >Home</a
      >
      <a
        href="#about-page"
        class="text-base font-semibold text-black no-underline btn dark:text-white"
        >About</a
      >
      <a
        href="#resume-page"
        class="text-base font-semibold text-black no-underline btn dark:text-white"
        >Resume</a
      >
      <a
        href="#work-page"
        class="text-base font-semibold text-black no-underline btn dark:text-white"
        >Works</a
      >
      <a
        href="#contact-page"
        class="text-base font-semibold text-black no-underline btn dark:text-white"
        >Contact</a
      >
    </div>
  </div>
</template>

<script>
import DarkMode from "../components/DarkMode.vue";
import Muneeb from "../components/icons/Muneeb.vue";

export default {
  name: "Contact",
  props: ["isDark"],
  data() {
    return {
      scrollPosition: null,
      active: null,
    };
  },
  methods: {
    updateScroll() {
      this.scrollPosition = window.scrollY;
    },
  },
  mounted() {
    window.addEventListener("scroll", this.updateScroll);
  },
  components: { DarkMode, Muneeb },
};
</script>

<style scoped>
.textColor {
  color: #101010;
}

.colorChange {
  color: white !important;
  transition: all 0.2s;
}

.bgBlack {
  background-color: #101010;
  transition: all 0.2s;
}

.active {
  color: red;
}
</style>
